// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"168":"c07afafc","408":"90644285"}[chunkId] + ".css";
};